import { useSuspenseQuery } from '@tanstack/react-query';

import { QUERY_DEFAULTS } from '@/shared/lib/constants/api';
import { dagKeys } from '@/shared/lib/query/queryKeys';

import { fetchDagDashboardDetailApi } from '@/entities/dag/api';

export const useDagDashboardDetail = (dagUuid: string) => {
  return useSuspenseQuery({
    queryKey: dagKeys.dagDashboardDetail(dagUuid),
    queryFn: () =>
      fetchDagDashboardDetailApi({
        dagUuid,
      }),
    staleTime: QUERY_DEFAULTS.STALE_TIME.SHORT,
    gcTime: QUERY_DEFAULTS.GC_TIME.MEDIUM,
    retry: false,
  });
};
